import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {map, mergeMap, catchError} from 'rxjs/operators';
import {of} from 'rxjs';
import {ApiService} from '../../../core/http/api.service';
import {LoadUserDetailsActionParams} from '../../models/user.model';
import {GetUserDetailsByIdResponseModel} from '../../../shared/models/users/users.models';
import { SellerDetailsActions } from '../../actions/user/seller-details.actions';

@Injectable()
export class SellerDetailsEffects {

   loadSellerDetails$ = createEffect(() => this.actions$
    .pipe(
      ofType(SellerDetailsActions.loadSellerDetails),
      mergeMap(
        (data: LoadUserDetailsActionParams) => this.api.Users.getUserDetailsById(data.id, data.params)
          .pipe(
            map((response: GetUserDetailsByIdResponseModel) => SellerDetailsActions.loadSellerSuccess(response)),
            catchError(error => of(SellerDetailsActions.loadSellerFailure(error)))
          )
      )
    ));

  constructor(
    private actions$: Actions,
    private api: ApiService
  ) {}
}
